import type GameSet from "../../GameSet";
import { applyAssignment } from "./apply";
import { buildFillContext } from "./context";
import {
  assignmentCost,
  bestDoublesOrder,
  buildRepeatScorer,
  canCoexist,
  compareCost,
  countUnitCombinations,
  gameGroupImbalance,
  isValidAssignment,
  scoreLevelBalanceForGame,
} from "./cost";
import { solve } from "./solve";

export type { Assignment, FillContext, FillMode } from "./types";
export type { RepeatScorer, SetCost } from "./cost";

export {
  applyAssignment,
  assignmentCost,
  bestDoublesOrder,
  buildFillContext,
  buildRepeatScorer,
  canCoexist,
  compareCost,
  countUnitCombinations,
  gameGroupImbalance,
  isValidAssignment,
  scoreLevelBalanceForGame,
  solve,
};

export function fillGameSet(gameSet: GameSet, opts?: { seed?: number }): void {
  const ctx = buildFillContext(gameSet, opts);
  const assignment = solve(ctx);
  applyAssignment(gameSet, assignment);
}
